import {useForm} from 'react-hook-form'
import {ConfirmationModal} from '../../../../components/ConfirmationModal'
import {SupplierMappingDetails} from '../../context'
import {yupResolver} from '@hookform/resolvers/yup'
import {useContext, useState, useEffect} from 'react'
import {SUPPLIER_MAPPING_DEFAULT_VALUES} from '../../utils'
import {createSupplierMappingSchema} from '../../validations'
import Loading from '../../../loading'
import InfiniteScrollWrapper from '../../../../components/InfiniteScrollWrapper'
import Search from '../../../../components/Search'
import NoDataFound from '../../../../components/NoDataFound'

const CreateSupplierMappingModal = ({supplierMapping, isEdit = false, onClose}: any) => {
  const [selectedProducts, setSelectedProducts] = useState<string[]>([])
  const {
    allProducts,
    onAddProducts,
    isOperationLoading,
    isLoading,
    onSearchProducts,
    onPageChangeProducts,
    isLoadingAllProducts,
  } = useContext(SupplierMappingDetails)

  const {handleSubmit, setError, setValue} = useForm({
    defaultValues: SUPPLIER_MAPPING_DEFAULT_VALUES(isEdit, supplierMapping),
    resolver: yupResolver(createSupplierMappingSchema(isEdit)),
    mode: 'onChange',
  })

  // Sync selectedProducts with form product_ids
  useEffect(() => {
    setValue('product_ids', selectedProducts)
  }, [selectedProducts, setValue])

  const onSubmit = (data: any) => {
    onAddProducts(data, setError)
  }

  const handleProductSelection = (productId: string) => {
    if (selectedProducts.includes(productId)) {
      setSelectedProducts(selectedProducts.filter((id) => id !== productId))
    } else {
      setSelectedProducts([...selectedProducts, productId])
    }
  }

  const sortedProducts = [
    ...allProducts.filter((p) => selectedProducts.includes(p.product_id)),
    ...allProducts.filter((p) => !selectedProducts.includes(p.product_id)),
  ]

  return (
    <ConfirmationModal
      show={true}
      onClose={onClose}
      onAction={handleSubmit(onSubmit)}
      title={`Add Product`}
      actionName={isEdit ? 'Save' : 'Create'}
      actionBtnClass='btn-primary'
      isOperationLoading={isOperationLoading}
      isDataLoading={isLoading}
      isDisabled={selectedProducts.length === 0}
      dialogClassName='modal-dialog modal-lg'
      body={
        <>
          <div className='d-flex align-items-center justify-content-between mt-5 mb-5'>
            <Search
              placeholder='Search for a product'
              onSearch={(value) => {
                onSearchProducts(value)
              }}
            />
          </div>
          <InfiniteScrollWrapper
            name='ip'
            loadMore={onPageChangeProducts}
            data={allProducts}
            height={450}
          >
            <div className='table-responsive position-relative'>
              <div className='table-loader-wrapper'>
                <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-2'>
                  <thead className='table-row-bordered text-uppercase'>
                    <tr className='fs-6 fw-semibold text-muted'>
                      <th className='min-w-50px'></th>
                      <th className='min-w-150px'>{'Sku'}</th>
                      <th className='min-w-200px'>{'Products'}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {allProducts && allProducts.length > 0
                      ? sortedProducts.map((row: any) => (
                          <tr key={row['product_id']}>
                            <td>
                              <div
                                className={
                                  'form-check form-check-sm form-check-custom text-capitalize'
                                }
                              >
                                <input
                                  type='checkbox'
                                  className='form-check-input cursor-pointer'
                                  checked={selectedProducts.includes(row['product_id'])}
                                  onChange={() => handleProductSelection(row['product_id'])}
                                />
                              </div>
                            </td>
                            <td>{row['sku']}</td>
                            <td>{row['product_name']}</td>
                          </tr>
                        ))
                      : !isLoadingAllProducts && <NoDataFound colspan={4} />}
                  </tbody>
                </table>
                {isLoadingAllProducts && <Loading />}
              </div>
            </div>
          </InfiniteScrollWrapper>
        </>
      }
    />
  )
}

export default CreateSupplierMappingModal
